/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Placewebneedaddress3Inputs */

const en_placewebneedaddress3 = /** @type {(inputs: Placewebneedaddress3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Street, city and country are needed to put the place on the map.`)
};

const de_placewebneedaddress3 = /** @type {(inputs: Placewebneedaddress3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Straße, Ort und Land werden gebraucht, um den Ort auf die Karte zu setzen.`)
};

/**
* | output |
* | --- |
* | "Street, city and country are needed to put the place on the map." |
*
* @param {Placewebneedaddress3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const placewebneedaddress3 = /** @type {((inputs?: Placewebneedaddress3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Placewebneedaddress3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_placewebneedaddress3(inputs)
	return de_placewebneedaddress3(inputs)
});
export { placewebneedaddress3 as "placeWebNeedAddress" }